import { render, staticRenderFns } from "./FichaDesenvolvimentoBimestral.vue?vue&type=template&id=7ee2c3fc"
import script from "./FichaDesenvolvimentoBimestral.vue?vue&type=script&lang=js"
export * from "./FichaDesenvolvimentoBimestral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports